"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PMT = void 0;
exports.PMT = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:PMT not implemented');
    },
};
//# sourceMappingURL=pmt.js.map